
var MarkLogic = require("clover/panelBusLogic/MarkLogic");
var instance = null;
var dt = 0.1;
ContinueCheckManager = xClass("ContinueCheckManager");
ContinueCheckName = {
    kShareReward: "happycoin", //风车币不足分享获得风车币（应该要和fetchHelpRewards和shareInfoList接口内的参数shareType相同）
    kCoinNotEnoughShare: "coinNotEnough",
    kFriendPvp: "pvp",
    kStarDrawReward: "newchest_reward",
    kAdProp: "ad_prop",
    kAdGacha: "AD_GACHA",
    kGachaAccumulate: "GACHA_ACCUMULATE"
};
ContinueCheckManager.getInstance = function () {
    if (!instance) {
        instance = ContinueCheckManager.new();
    }
    return instance
}
ContinueCheckManager.prototype.ctor = function () {
    var self = this;
}
ContinueCheckManager.prototype.init = function () {
    var self = this;
    self.status = 1; // 1正常，0暂停
    self.checkDict = {};
    self.curSuccessCb = null;
    self.curFailCb = null;
    self.updateTimers = cc.director.getScheduler().scheduleScriptFunc(handler(self, self.checkUpdate), dt);

    CfgManager.load("game").then((dataMap)=>{
        self.initShareReward();
        CfgManager.release("game");
    }).catch((err) => {
        console.error("load game config failed!", err);
    });  
}
/**
 * 初始化分享检查器
 */
ContinueCheckManager.prototype.initShareReward = function(){
    var self = this

    self.initHappyCoin()
    self.initCoinNotEnough()
}
/**
 * 初始化风车币获取检查
 */
ContinueCheckManager.prototype.initHappyCoin = function () {
    var config = CfgManager.get("game");
    var duration = config["get_happycoin_share_lifetime"] / 1000;
    var self = this;
    self.pause();

    var showReward = function(rewards){
        var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
        GetRewardsPanel.show(ContinueCheckName.kShareReward, rewards, true);
    }

    var onSuccess = function(evt){
        cc.log("------------------initShareReward-----------------");
        cc.log(evt.data);
        if (evt.data.shareRewards && evt.data.shareRewards.length > 1){
            var rewards = new Array();
            for(var i = 1; i < evt.data.shareRewards.length; i++){
                rewards.push(evt.data.shareRewards[i]);
            }
            showReward(rewards);
        }
        if (evt.data.shareIdList && evt.data.shareIdList.length > 1){
            for(var i = 1; i < evt.data.shareIdList.length; i++){
                self.registCheck(ContinueCheckName.kShareReward, evt.data.shareIdList[i], 10, duration, showReward, null);
            }
        }
        self.resume();
    }
    var onFail = function(evt){
        cc.error(evt);
        self.resume();
    }
    var http = FetchHelpRewardsHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(ContinueCheckName.kShareReward);
}
/**
 * 初始化银币获取检查
 */
ContinueCheckManager.prototype.initCoinNotEnough = function () {
    var config = CfgManager.get("game");
    var duration = config["buy_props_coinlack_sharelifetime"] / 1000;
    var self = this;
    self.pause();

    var showReward = function(rewards){
        var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
        GetRewardsPanel.show(ContinueCheckName.kCoinNotEnoughShare, rewards, true);
    }

    var onSuccess = function(evt){
        if (evt.data.shareRewards && evt.data.shareRewards.length > 1){
            var rewards = new Array();
            for(var i = 1; i < evt.data.shareRewards.length; i++){
                rewards.push(evt.data.shareRewards[i]);
            }
            showReward(rewards);
        }
        if (evt.data.shareIdList && evt.data.shareIdList.length > 1){
            for(var i = 1; i < evt.data.shareIdList.length; i++){
                self.registCheck(ContinueCheckName.kCoinNotEnoughShare, evt.data.shareIdList[i], 10, duration, showReward, null);
            }
        }
        self.resume();
    }
    var onFail = function(evt){
        cc.error(evt);
        self.resume();
    }
    var http = FetchHelpRewardsHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(ContinueCheckName.kCoinNotEnoughShare);
}
/**
 * 暂停检查器
 */
ContinueCheckManager.prototype.pause = function(){
    var self = this;
    self.status = 0;
}
/**
 * 恢复检查器
 */
ContinueCheckManager.prototype.resume = function(){
    var self = this;
    self.status = 1;
}
/**
 * 注册检查事件
 * @param   name            事件类型
 * @param   checkParams     事件唯一标识符（例如shareId）
 * @param   interval        事件检查周期
 * @param   duration        时间检查生命周期
 * @param   successCb       监听结果成功回调      
 * @param   failCb          监听结果失败回调
 */
ContinueCheckManager.prototype.registCheck = function(name, checkParams, interval, duration, successCb, failCb){
    var self = this;
    var hasName = false;
    for(var key in self.checkDict){
        if (key == name && self.checkDict[key]){
            hasName = true;
            self.checkDict[key].checkList.push(checkParams);
        }
    }
    if (!hasName){
        self.checkDict[name] = {
            interval: interval,         //  检查周期
            nextTime: 0,
            successCb: successCb,       //  成功回调
            failCb: failCb,             //  失败回调
            failTimes: 0,               //  失败次数
            duration: duration,         //  检查保持时长
            checkList: [],              //  检查内容
        }
        self.checkDict[name].checkList.push({params:checkParams, duration:duration});
    }
}
/**
 * 进行轮询检查，达到轮询周期则发送检查请求
 */
ContinueCheckManager.prototype.checkUpdate = function(){
    var self = this;
    if (!self.status){
        return;
    }
    if (!MarkLogic.isCurRunning()) {
        var hasSendHttp = false;
        for(var key in self.checkDict){
            if (self.checkDict[key] == null){
                //  当前事件没有监听，直接跳过
                continue;
            } else {
                self.checkDict[key].nextTime -= dt;     //  距离下次这个类型查询的时间
                self.checkDict[key].duration -= dt;     //  距离结束这个类型查询的时间
                if (!hasSendHttp && self.checkDict[key].nextTime <= 0){
                    var scene = cc.Director.getInstance().getRunningScene();
                    // 失败复活界面点开的金币不足界面存在的时候也会要查询
                    if (scene.name != "HomeScene" && (scene.name != "GameScene" || scene.needContinueCheck == false)){
                        // 不在主界面不发请求
                        continue;
                    }
                    // 在主界面并且时间到了，一次只请求一个类型
                    self.status = 0;
                    self.checkDict[key].nextTime += self.checkDict[key].interval;       //  为了保证多周期的时间准确性，因此这里用+=，而不是单纯的把时间重置为一个周期时间
                    self.checkDict[key].failTimes = 0;                                  //  检查失败次数

                    self.curSuccessCb = self.checkDict[key].successCb;
                    self.curFailCb = self.checkDict[key].failCb;
                    self.curKey = key;
                    function onSuccess(evt) {
                        if (evt.data.shareRewards && evt.data.shareRewards.length > 1){
                            if (self.curSuccessCb){
                                var rewards = new Array();
                                for(var i = 1; i < evt.data.shareRewards.length; i++){
                                    rewards.push(evt.data.shareRewards[i]);
                                }
                                self.curSuccessCb(rewards, self.curKey);
                            }
                        }
                        if (evt.data.shareIdList && evt.data.shareIdList.length > 1){
                            // 更新之后还需要查询的列表
                            if (self.curKey == ContinueCheckName.kShareReward) {
                                //  风车币不足会保留尚未失效的ShareId，银币不足则因为不存在单个链接的点击限制，不需要更新ShareId状态
                                self.checkDict[self.curKey].checkList = new Array();
                                for(var i = 1; i < evt.data.shareIdList.length; i++){
                                    self.checkDict[self.curKey].checkList.push(evt.data.shareIdList[i]);
                                }
                            }
                        }else{
                            // 查询的列表没有了
                            self.checkDict[self.curKey] = null;
                        }
                        // 到查询时间限制就不要这个类型了
                        if (self.checkDict[self.curKey] && self.checkDict[self.curKey].duration < 0){
                            self.checkDict[self.curKey] = null;
                        }
                        self.status = 1;
                        cc.log(self.checkDict)
                    }
                    function onFail(evt) {
                        cc.error(evt.data);
                        self.status = 1;
                        self.checkDict[key].failTimes += 1;
                        self.checkDict[key].nextTime = self.checkDict[key].interval;
                        // 到查询时间限制或者连续失败三次就不要这个类型了
                        if (self.checkDict[self.curKey].duration < 0 || self.checkDict[key].failTimes > 3){
                            if (self.checkDict[self.curKey].failCb) {
                                self.checkDict[self.curKey].failCb();
                            }
                            self.checkDict[self.curKey] = null;
                        }
                    }
                    var http = FetchHelpRewardsHttp.new();
                    http.addEventListener(Events.kComplete, onSuccess);
                    http.addEventListener(Events.kError, onFail);
                    http.addEventListener(Events.kCancel, onFail);
                    http.load(key);

                    hasSendHttp = true;
                }
            }
        }
    }
}
module.exports = ContinueCheckManager